import { ContentBlock } from 'draft-js';

import styles from './styles/BlockStyles.modules.scss';

export function blockStyleFn(contentBlock: ContentBlock) {
  const type = contentBlock.getType();
  return styles[type];
}
